export enum EvaSize {
  Small = '-sm',
  Medium = '-md',
  Large = '-lg',
}

export enum EvaButtonVariation {
  Primary = '-primary',
  Secondary = '-secondary',
  Link = '-link',
  White = '-white',
  Dark = '-dark',
  LinkDark = '-link-dark',
  LinkLoyalty = '-link-loyalty',
}

export enum EvaButtonGhostVariation {
  Darken = '-darken',
  Lighten = '-lighten',
  WhiteLoyalty = '-white-loyalty',
}

export enum EvaLabelPosition {
  TopRight = '-top-right',
  TopLeft = '-top-left',
  BottomRight = '-bottom-right',
  BottomLeft = '-bottom-left',
}

export enum EvaTooltipPosition {
  TopRight = '-top -right',
  TopLeft = '-top -left',
  TopCenter = '-top -center',
  BottomRight = '-bottom -right',
  BottomLeft = '-bottom -left',
  BottomCenter = '-bottom -center',
  LeftInline = '-left-inline',
  RightInline = '-right-inline',
}

export enum EvaMessageVariation {
  Info = '-info',
  InfoSecondary = '-info-secondary',
  Warning = '-warning',
  WarningSecondary = '-warning-secondary',
  Success = '-success',
  SuccessSecondary = '-success-secondary',
  Error = '-error',
}

export enum EvaInputIconPosition {
  Left = '-icon-left',
  Right = '-icon-right',
}

export enum EvaNavDotsPosition {
  Left = '-left',
  Center = '-center',
  Right = '-right',
}

export enum EvaNavDotsVariation {
  Positive = '',
  Negative = '-lighten',
}

export enum EvaNavDotsSize {
  Default = '',
  Large = '-lg',
  Small = '-sm',
}

export enum EvaTooltipCoachMarkColor {
  White = '-white',
  Info = '-info',
}

export enum EvaTooltipCoachMarkPosition {
  TopRight = '-top -right',
  TopLeft = '-top -left',
  TopCenter = '-top -center',
  BottomRight = '-bottom -right',
  BottomLeft = '-bottom -left',
  BottomCenter = '-bottom -center',
}

export enum EvaTooltipNotHoverBehavior {
  Default = '',
  All = '-not-hover',
  Small = '-not-hover-small',
  Medium = '-not-hover-medium',
  Large = '-not-hover-large',
}
// Driver
export enum EvaDriverHierarchy {
  J1 = '-j1',
  J2 = '-j2',
  J3 = '-j3',
  J4 = '-j4',
  J5 = '-j5',
}

export enum EvaDriverStyle {
  Benefits = '-benefits',
  Info = '-info',
  Attributes = '-attributes',
  Urgent = '-urgent',
  Loyalty = '-loyalty',
  Unbeatable = '-unbeatable',
}
